import { Dispatch, SetStateAction, useEffect } from "react";
import { TransformedEvent } from "../../Utils/ParsingUtil";
import { useCallbackState } from "../../Utils/GlobalContext";
import { getColor } from "../../CalendarProps/CalendarProps";

interface CheckBoxProps {
  checkedAppointment: string[];
  setCheckedAppointment: Dispatch<SetStateAction<string[]>>;
  filterAppointments?: boolean;
}

export function filterByTopic(
  appointments: TransformedEvent[],
  checkedAppointment: string[]
) {
  const filteredData: TransformedEvent[] = [];
  for (const item of appointments) {
    if (checkedAppointment.includes(item.resource.topic.replace(/&/g, " & "))) {
      filteredData.push(item);
    }
  }
  return filteredData;
}

export function filterByDateRange(
  appointments: TransformedEvent[],
  rangeStartDate: Date,
  rangeEndDate: Date
) {
  const filteredData: TransformedEvent[] = [];
  rangeStartDate.setHours(0);
  for (const item of appointments) {
    const startDate = new Date(item.start);
    if (startDate >= rangeStartDate && startDate <= rangeEndDate) {
      filteredData.push(item);
    }
  }
  return filteredData;
}

export const CheckboxList = ({
  checkedAppointment,
  setCheckedAppointment,
  filterAppointments,
}: CheckBoxProps) => {
  const { appointments, setFilteredAppointmnets } = useCallbackState();
  const allTopics = appointments.map((item) => item.resource.topic);
  const uniqueTopics = allTopics.filter(
    (value, index, array) => array.indexOf(value) === index
  );
  const modifiedTopics = uniqueTopics.map((item) => item.replace(/&/g, " & "));
  useEffect(() => {
    if (filterAppointments) {
      setFilteredAppointmnets(filterByTopic(appointments, checkedAppointment));
    }
  }, [
    appointments,
    checkedAppointment,
    filterAppointments,
    setFilteredAppointmnets,
  ]);

  const handleCheckboxChange = (checkboxName: string, isChecked: boolean) => {
    setCheckedAppointment((prevSelected) => {
      if (isChecked) {
        return [...prevSelected, checkboxName];
      } else {
        return prevSelected.filter((name) => name !== checkboxName);
      }
    });
  };
  if (checkedAppointment.length < 1) {
  }
  const CheckBoxes = modifiedTopics.map((topic) => (
    <label className="checkbox-label" key={topic}>
      <div
        className="topic-hints"
        style={{ backgroundColor: getColor(topic) }}
      ></div>
      <input
        className="input-checkbox"
        type="checkbox"
        checked={checkedAppointment.includes(topic)}
        onChange={(e) => handleCheckboxChange(topic, e.target.checked)}
      />
      {topic}
      <span
        className={`custom-checkbox ${
          checkedAppointment.length < 1 ? "checkbox-red" : ""
        }`}
      ></span>
    </label>
  ));
  return <div> {CheckBoxes} </div>;
};

export default CheckboxList;
